@if (busy) {
  <div class="flex flex-col items-center justify-center py-8">
    <div class="text-center">
      <div class="relative w-20 h-20 mx-auto mb-6">
        <div class="absolute inset-0 rounded-full border-4 border-green-200 animate-spin"></div>
        <div class="absolute inset-2 rounded-full border-4 border-green-400 border-t-transparent animate-spin" style="animation-direction: reverse; animation-duration: 1.5s;"></div>
        <div class="absolute inset-0 flex items-center justify-center">
          <mat-icon class="text-green-600 text-2xl animate-pulse">security</mat-icon>
        </div>
      </div>
      <h3 class="mb-2 text-gray-700 inline-flex">
        <mat-icon class="mr-2">credit_card</mat-icon>
        Secure Connection Active
      </h3>
      <p class="text-gray-500">Please wait...</p>
    </div>
  </div>
}
<div [class.hidden]="busy">
  <div class="p-2 sm:p-4">
    <form [formGroup]="creditCardValidationForm" (submit)="onSubmit()">
      <div class="w-full pb-2">
        <div class="flex" [class.hidden]="!assignToAllJobs">
          <mat-checkbox formControlName="updateJobs">Assign To All Jobs</mat-checkbox>
        </div>
        @if (sidemarkOptions?.length > 1) {
          <div class="flex">
            <mat-checkbox formControlName="updateProjects">Assign To Sidemark</mat-checkbox>
          </div>
        }
      </div>

      @if (showSidemark) {
        <div class="w-full">
          <mat-form-field class="w-full md:mt-2">
            <mat-label class="text-l">Sidemark</mat-label>
            <mat-select formControlName="projectIds" multiple>
              @for (item of sidemarkOptions; track item?.value) {
                <mat-option [disabled]="isDisableSideMarkOption(item.value.toString())" [value]="item.value">{{ item.label
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }

      <div [class.hidden]="userCreditCard?.id" class="w-full pb-4">
        <div class="flex flex-col w-full gap-3">
          <div>
            <label for="cardNumber" class="hosted-field--label">Card Number @if (cardType) {
              <span
              >({{cardType}})</span>
            }</label>
            <div class="hosted-field text-field bg-white" id="cardNumber"></div>
            <small class="helper-text"></small>
          </div>
          <div class="grid grid-cols-2 gap-x-2">
            <div>
              <label for="expirationMonth" class="hosted-field--label">Expiration Month</label>
              <div class="hosted-field bg-white" id="expirationMonth"></div>
              <small class="helper-text"></small>
            </div>
            <div>
              <label for="expirationYear" class="hosted-field--label">Expiration Year</label>
              <div class="hosted-field bg-white" id="expirationYear"></div>
              <small class="helper-text"></small>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-x-2">
            <div>
              <label for="cardCVV" class="hosted-field--label">Security Code</label>
              <div class="hosted-field bg-white" id="cardCVV"></div>
              <small class="helper-text"></small>
            </div>
            <div>
              <label for="billingZipCode" class="hosted-field--label">Billing Zip Code</label>
              <div class="hosted-field bg-white" id="billingZipCode"></div>
              <small class="helper-text"></small>
            </div>
          </div>
        </div>
      </div>

      <div>
        <mat-form-field class="w-full">
          <mat-label class="text-l">Nickname</mat-label>
          <input matInput type="text" formControlName="nickname" id="nickname">
        </mat-form-field>
      </div>

      <div class="flex flex-row justify-between">
        <button type="button" class="bg-white" mat-raised-button color="default" (click)="onCancel()">
          <mat-icon>
            arrow_back
          </mat-icon>
          Cancel
        </button>

        @if (!userCreditCard?.id) {
          <button type="submit"
            [disabled]="!creditCardValidationForm.valid || creditCardValidationForm.pristine"
            id="submit-credit-card-form" mat-raised-button color="primary">
            Save @if (cardType) {
            <span> {{cardType}}</span>
          }
          <mat-icon>
            arrow_forward
          </mat-icon>
        </button>
      }

      @if (userCreditCard?.id) {
        <button type="submit"
          [disabled]="!creditCardValidationForm.valid || creditCardValidationForm.pristine" mat-raised-button
          color="primary">
          Save @if (cardType) {
          <span> {{cardType}}</span>
        }
        <mat-icon>
          arrow_forward
        </mat-icon>
      </button>
    }
  </div>

</form>
</div>
</div>
